import { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl';
import { useAtomValue } from 'jotai';

import { tcAreaPreviewAtom } from 'components/type-curve-workspace/atoms';

export const TcAreaPreviewLayer = () => {
  const preview = useAtomValue(tcAreaPreviewAtom);

  const geojson = useMemo((): GeoJSON.FeatureCollection | null => {
    if (!preview?.geometry) return null;
    return {
      type: 'FeatureCollection',
      features: [
        { type: 'Feature', geometry: preview.geometry, properties: {} },
      ],
    };
  }, [preview?.geometry]);

  if (!geojson) return null;

  return (
    <Source id="tc-area-preview" type="geojson" data={geojson}>
      <Layer
        id="tc-area-preview-fill"
        type="fill"
        paint={{ 'fill-color': '#2196F3', 'fill-opacity': 0.1 }}
      />
      <Layer
        id="tc-area-preview-outline"
        type="line"
        paint={{
          'line-color': '#2196F3',
          'line-width': 2,
          'line-dasharray': [4, 2],
        }}
      />
    </Source>
  );
};
